import { render } from "./PropertyServicesCreating.vue?vue&type=template&id=9a56cfd2&ts=true"
import script from "./PropertyServicesCreating.vue?vue&type=script&lang=ts"
export * from "./PropertyServicesCreating.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__